export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'About Me',

  description:
    "Welcome! I'm Calvin, an aspiring Software Engineer located in Los Angeles, CA. I have a passion for working on diverse projects that encompass coding, management, and engineering. My technical background is quite extensive, ranging from Cybersecurity, Software Development, DevOps, Service Engineering, Networking, to Operating System troubleshooting. I've developed a unique set of skills that I've demonstrated through the successful delivery of various projects, and I have a talent for quickly learning new technologies. I strongly believe that collaboration, accountability, and teamwork are essential ingredients for success. I'm not afraid to take risks and step outside my comfort zone, and I embrace failures as opportunities for growth. Please feel free to explore my website to learn more about me. If you have any inquiries or want to collaborate, let's connect!",
  headline: 'My Personal Interests',
  description1:
    "When I am not doing anything related to coding, I enjoy spending my time working out, Playing guitar, Hiking, and Learning new skills",
  buttonLabel: 'Contact Me',
  imgStart: false,
  img: require('../../images/Calvin.JPG'),
  alt: 'Calvin Nguyen',
  dark: true,
  primary: true,
  darkText: false
};


export const Contact = {
  id: 'signup',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Contact',
  description:
    "If you have any questions or would want to get in contact with me, click the button below and I'll get back to you as soon as possible!",
  buttonLabel: 'Contact Me',
  imgStart: true,
  img: require('../../images/svg-3.png'),
  alt: 'Contact',
  dark: true,
  primary: true,
  darkText: false
};
